/*
  SBR Perfect Storm, Push stage prelude (reviewer R-P1, 2026-10-22). The BIGFOOT refresh below runs only
  where DEV runs it: DEV loads this file for BIGFOOT only while a BIGFOOT counter is active. The Push
  surfaces load it on more pages, with data-storm-push-only on their script tags. When EVERY tag on the
  page that loads this file carries that flag, no BIGFOOT markup asked for the refresh, so window.SbrStorm
  is set to an idle stub and the BIGFOOT code returns at its first line. Any BIGFOOT tag: no change.
*/
(function () {
  'use strict';
  if (window.SbrStorm) return;
  var tags = document.getElementsByTagName('script');
  var mine = 0;
  var pushOnly = 0;
  for (var i = 0; i < tags.length; i++) {
    if (!/\/sbr-storm\.js(\?|#|$)/.test(tags[i].getAttribute('src') || '')) continue;
    mine++;
    if (tags[i].hasAttribute('data-storm-push-only')) pushOnly++;
  }
  if (mine > 0 && pushOnly === mine) window.SbrStorm = { data: null, refresh: function () {}, idle: true };
})();
/*
  SBR Perfect Storm: live counter refresh. 2026-10-21.
  Loaded with defer only by markup that renders a storm element. Safe to include more than once.

  Every 60 s, and only while a counter is on screen (IntersectionObserver) and the tab is visible, it
  (reviewer 2026-10-21: the check timer itself exists only in that state and is cleared otherwise)
  fetches sections/sbr-storm-counter through the Section Rendering API ('/?section_id=sbr-storm-counter')
  and copies the server numbers into the page. BIGFOOT offer hooks (an element whose ancestor-or-self
  has data-storm-offer set to anything but "bigfoot" is left alone, so a future Push card can use the
  same names under data-storm-offer="push"):
    [data-storm-left]   text = units left at the sale price (promo roller plus promo kit, capped at limit)
    [data-storm-bar]    style.width = left / limit; aria-valuenow / aria-valuemax on its progressbar
    [data-storm-state]  attribute value = active | ended | off
                        active: sale on and units left. ended: sale switched on, promo product on the
                        storefront, no units left. off: switched off in theme settings, or no promo
                        product on the storefront. Consumers hide on "off".
    [data-storm-uses]   "bf", "kit" or "bf kit": a buy box that is showing a promo price. When a promo
                        it shows has sold out (or the sale is switched off), the page reloads ONCE so the
                        server renders the regular price. A sessionStorage key per page and state makes a
                        loop impossible; if storage is blocked it does not reload at all.
  A failed or malformed fetch changes nothing: the last server-rendered values stay on the page.
  Nothing is estimated, animated toward, or invented. No timers, no viewer counts.
  Fires document event 'sbr:storm' (detail = parsed data) after each good refresh.
  Uses its own data-storm-* names on purpose: Halo's theme.js rewrites its countdown attributes.
*/
(function () {
  'use strict';
  if (window.SbrStorm) return;

  var PERIOD = 60000;
  var SEL = '[data-storm-counter],[data-storm-left],[data-storm-bar],[data-storm-state]';
  var routes = window.Shopify && window.Shopify.routes;
  var root = (routes && routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var url = root + '?section_id=sbr-storm-counter';
  var last = Date.now();
  var busy = false;
  var onScreen = 0;
  var timer = null;
  var api = window.SbrStorm = { data: null, refresh: function () { refresh(true); } };

  function num(v) {
    if (v === null || v === undefined) return null;
    v = String(v).trim();
    return /^-?\d+$/.test(v) ? parseInt(v, 10) : null;
  }

  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }

  function isBigfoot(el) {
    var o = el.closest ? el.closest('[data-storm-offer]') : null;
    if (!o) return true;
    var k = o.getAttribute('data-storm-offer');
    return !k || k === 'bigfoot';
  }

  function parse(html) {
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return null; }
    var el = doc && doc.getElementById('sbr-storm-counter-data');
    if (!el) return null;
    var d = {
      active: num(el.getAttribute('data-active')),
      left: num(el.getAttribute('data-left')),
      limit: num(el.getAttribute('data-limit')),
      exists: num(el.getAttribute('data-exists')),
      on: num(el.getAttribute('data-on')),
      bfLeft: num(el.getAttribute('data-bf-left')),
      kitLeft: num(el.getAttribute('data-kit-left'))
    };
    if (d.active === null || d.left === null || d.limit === null || d.exists === null) return null;
    if (d.active === 1 && d.limit > 0) d.state = 'active';
    else if (d.exists === 1 && d.on === 1 && d.limit > 0) d.state = 'ended';
    else d.state = 'off';
    return d;
  }

  function reloadOnce(sig) {
    var key = 'sbrStormReload:' + location.pathname + ':' + sig;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch (e) {
      return;
    }
    location.reload();
  }

  function apply(d) {
    var left = Math.max(0, d.left);
    if (d.limit > 0 && left > d.limit) left = d.limit;
    var pct = d.limit > 0 ? Math.round(left * 100 / d.limit) : 0;

    each('[data-storm-left]', function (el) {
      if (isBigfoot(el) && el.textContent !== String(left)) el.textContent = String(left);
    });
    each('[data-storm-bar]', function (el) {
      if (!isBigfoot(el)) return;
      el.style.width = pct + '%';
      var pb = el.getAttribute('role') === 'progressbar' ? el : (el.closest ? el.closest('[role="progressbar"]') : null);
      if (pb) {
        pb.setAttribute('aria-valuenow', String(left));
        pb.setAttribute('aria-valuemax', String(d.limit));
      }
    });
    each('[data-storm-state]', function (el) {
      if (isBigfoot(el)) el.setAttribute('data-storm-state', d.state);
    });
    each('[data-storm-uses]', function (el) {
      var uses = ' ' + (el.getAttribute('data-storm-uses') || '') + ' ';
      var bfGone = uses.indexOf(' bf ') > -1 && (d.active !== 1 || (d.bfLeft !== null && d.bfLeft < 1));
      var kitGone = uses.indexOf(' kit ') > -1 && (d.active !== 1 || (d.kitLeft !== null && d.kitLeft < 1));
      if (bfGone || kitGone) reloadOnce(d.state + (bfGone ? '-bf' : '') + (kitGone ? '-kit' : ''));
    });
  }

  function refresh(force) {
    if (busy) return;
    if (!force && (document.visibilityState === 'hidden' || onScreen < 1)) return;
    busy = true;
    last = Date.now();
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('storm counter ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var d = parse(html);
        if (!d) return;
        api.data = d;
        apply(d);
        try { document.dispatchEvent(new CustomEvent('sbr:storm', { detail: d })); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function stale() {
    return Date.now() - last >= PERIOD;
  }

  function sync() {
    var want = document.visibilityState !== 'hidden' && onScreen > 0;
    if (want && !timer) {
      timer = setInterval(function () { if (stale()) refresh(false); }, PERIOD / 4);
      if (stale()) refresh(false);
    } else if (!want && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function init() {
    var els = document.querySelectorAll(SEL);
    if (!els.length || !window.fetch || !window.DOMParser) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var was = en.target.__sbrStormOn === true;
          if (en.isIntersecting !== was) {
            en.target.__sbrStormOn = en.isIntersecting;
            onScreen += en.isIntersecting ? 1 : -1;
          }
        });
        sync();
      });
      Array.prototype.forEach.call(els, function (el) { io.observe(el); });
    } else {
      onScreen = 1;
      sync();
    }
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(true); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  SBR Perfect Storm: PUSH offer (STORM10) live counter. 2026-10-22. Appended below the BIGFOOT code,
  which is unchanged and never reads these hooks (the BIGFOOT script only looks at data-storm-counter,
  data-storm-left, data-storm-bar and data-storm-state; nothing here uses those names).

  Runs only when the page has an element with data-storm-offer="push" (Push PDP panel, homepage Push card,
  campaign bar, cart line). The first such element with data-storm-endpoint gives the endpoint (theme
  setting storm_counter_endpoint, https only), data-storm-max-age (minutes, theme setting
  storm_counter_max_age_minutes, 25 if missing) and data-storm-code (the code shown in the sold out line).

  GET endpoint -> 200 {"campaigns":[{campaign,status,cap,remaining,updated_at}, ...]} or 503.
  Fetched ONCE per page load, again on a back/forward cache restore, and again when the tab becomes
  visible after more than 60 s since the last fetch. No polling loop. 2.5 s timeout. credentials omit.
  The counter writes nothing to localStorage, sessionStorage or cookies: a number is never cached. The
  cart auto-apply (below, before init) keeps one sessionStorage flag per code, sbr_storm_auto_<CODE>.

  States (data-storm-push-state on every push root and on <html>):
    pending  before the first answer. The server prints "Offer details at checkout", no number, no bar.
    live     HTTP 200, exactly one storm-push row, status "live", cap a positive integer, remaining an
             integer 1..cap, updated_at no older than the max age (and at most 5 min ahead of this
             device's clock): "N of CAP left", the yellow bar at N / CAP.
    ended    status "sold_out" or "ended", or remaining 0 while live: "CODE is sold out. Promotion
             ended." Copy and apply controls hide; bar messages and Push card badges are removed.
    unknown  anything else (503, timeout, network or CORS error, draft, scheduled, paused, stale,
             malformed JSON, missing or duplicate row, bad numbers): "Offer details at checkout", no
             number, no bar fill.
  Hooks:
    [data-storm-push-line]          (in a root) text for the state; aria-live polite is on the markup
    [data-storm-push-meter]         (in a root) shown only while live; aria-valuenow/aria-valuemax follow
    [data-storm-push-fill]          (in a root) width N / CAP while live, 0 otherwise
    [data-storm-push-hide-ended]    hidden while ended
    [data-storm-push-show-ended]    shown only while ended
    [data-storm-push-remove-ended]  removed once ended
    [data-storm-copy="CODE"]        copy button: navigator.clipboard, select-text fallback
    [data-storm-push-qtymax] + data-storm-push-ids   (cart, code applied) max on those lines' quantity
                                    inputs. A hint only: values are never changed, checkout never blocked.
    [data-storm-push-cartline]      cart page line, hidden after a Halo cart change leaves no eligible line
  After Halo's 'cart-update' (the drawer re-renders its markup) the last answer is applied again; no
  new fetch. Fires document event 'sbr:storm-push' (detail {state, remaining, cap}) after each answer.
*/
(function () {
  'use strict';
  if (window.SbrStormPush) return;

  var CAMPAIGN = 'storm-push';
  var ROOT = '[data-storm-offer="push"]';
  var GAP = 60000;
  var TIMEOUT = 2500;
  var AHEAD = 300000;
  var DEFAULT_AGE = 25;
  var TXT_UNKNOWN = 'Offer details at checkout';

  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }

  function within(root, sel, fn) {
    if (root.matches && root.matches(sel)) fn(root);
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  function isInt(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n;
  }

  function config() {
    var roots = document.querySelectorAll(ROOT);
    var code = '';
    for (var i = 0; i < roots.length; i++) {
      if (!code) code = (roots[i].getAttribute('data-storm-code') || '').trim();
    }
    for (var j = 0; j < roots.length; j++) {
      var url = (roots[j].getAttribute('data-storm-endpoint') || '').trim();
      if (!url) continue;
      var age = parseInt(roots[j].getAttribute('data-storm-max-age'), 10);
      if (!isInt(age) || age < 1) age = DEFAULT_AGE;
      if (age > 1440) age = 1440;
      return { url: /^https:\/\/[^\s"'<>]+$/.test(url) ? url : '', maxAgeMs: age * 60000, code: code };
    }
    return { url: '', maxAgeMs: DEFAULT_AGE * 60000, code: code };
  }

  // res: null (timeout, network error) or {status, body}. Pure: no DOM, no clock of its own.
  function classify(res, nowMs, maxAgeMs) {
    var unknown = { state: 'unknown', remaining: null, cap: null };
    if (!res || res.status !== 200) return unknown;
    var body = res.body;
    if (!body || typeof body !== 'object' || Object.prototype.toString.call(body.campaigns) !== '[object Array]') return unknown;
    var row = null;
    var hits = 0;
    for (var i = 0; i < body.campaigns.length; i++) {
      var c = body.campaigns[i];
      if (c && typeof c === 'object' && c.campaign === CAMPAIGN) { row = c; hits++; }
    }
    if (hits !== 1) return unknown;
    if (row.status === 'sold_out' || row.status === 'ended') return { state: 'ended', remaining: 0, cap: isInt(row.cap) ? row.cap : null };
    if (row.status !== 'live') return unknown;
    var cap = row.cap;
    var rem = row.remaining;
    if (!isInt(cap) || cap < 1 || !isInt(rem) || rem < 0 || rem > cap) return unknown;
    if (rem === 0) return { state: 'ended', remaining: 0, cap: cap };
    var t = typeof row.updated_at === 'string' ? Date.parse(row.updated_at) : NaN;
    if (!isFinite(t)) return unknown;
    var age = nowMs - t;
    if (age > maxAgeMs || age < -AHEAD) return unknown;
    return { state: 'live', remaining: rem, cap: cap };
  }

  function request(url, cb) {
    var done = false;
    var ctrl = null;
    var timer = null;
    function end(res) {
      if (done) return;
      done = true;
      if (timer !== null) clearTimeout(timer);
      cb(res);
    }
    if (!url || typeof window.fetch !== 'function') { end(null); return; }
    try { if (typeof window.AbortController === 'function') ctrl = new window.AbortController(); } catch (e) { ctrl = null; }
    timer = setTimeout(function () {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      end(null);
    }, TIMEOUT);
    var opts = { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'default', redirect: 'follow' };
    if (ctrl) opts.signal = ctrl.signal;
    var p;
    try { p = window.fetch(url, opts); } catch (e) { end(null); return; }
    if (!p || typeof p.then !== 'function') { end(null); return; }
    p.then(function (r) {
      if (!r || r.status !== 200) { end({ status: r ? r.status : 0, body: null }); return; }
      return r.text().then(function (txt) {
        var body = null;
        try { body = JSON.parse(txt); } catch (e) { body = null; }
        end({ status: 200, body: body });
      });
    }).then(null, function () { end(null); });
  }

  function lineText(r, code) {
    if (r.state === 'live') return r.remaining + ' of ' + r.cap + ' left';
    if (r.state === 'ended') return (code || 'STORM10') + ' is sold out. Promotion ended.';
    return TXT_UNKNOWN;
  }

  function qtycap() {
    var m = document.querySelector('[data-storm-push-qtymax]');
    var max = m ? parseInt(m.getAttribute('data-storm-push-qtymax'), 10) : NaN;
    var ids = m ? ' ' + (m.getAttribute('data-storm-push-ids') || '') + ' ' : '';
    var on = isInt(max) && max > 0;
    each('cart-update-quantity[data-product]', function (el) {
      var input = el.querySelector('input[data-cart-quantity]');
      if (!input) return;
      var mine = on && ids.indexOf(' ' + el.getAttribute('data-product') + ' ') > -1;
      if (mine) {
        if (input.getAttribute('max') !== String(max)) input.setAttribute('max', String(max));
        input.setAttribute('data-storm-max', '1');
      } else if (input.getAttribute('data-storm-max') === '1') {
        input.removeAttribute('max');
        input.removeAttribute('data-storm-max');
      }
    });
  }

  function paint(r, code) {
    var st = r.state;
    document.documentElement.setAttribute('data-storm-push-state', st);
    each(ROOT, function (root) {
      root.setAttribute('data-storm-push-state', st);
      within(root, '[data-storm-push-line]', function (el) {
        var t = lineText(r, code);
        if (el.textContent !== t) el.textContent = t;
      });
      within(root, '[data-storm-push-meter]', function (el) {
        el.hidden = st !== 'live';
        var pb = el.getAttribute('role') === 'progressbar' ? el : el.querySelector('[role="progressbar"]');
        if (pb && st === 'live') {
          pb.setAttribute('aria-valuenow', String(r.remaining));
          pb.setAttribute('aria-valuemax', String(r.cap));
        }
      });
      within(root, '[data-storm-push-fill]', function (el) {
        var pct = st === 'live' ? Math.max(1, Math.min(100, Math.round(r.remaining * 100 / r.cap))) : 0;
        el.style.width = pct + '%';
      });
    });
    each('[data-storm-push-hide-ended]', function (el) { el.hidden = st === 'ended'; });
    each('[data-storm-push-show-ended]', function (el) { el.hidden = st !== 'ended'; });
    if (st === 'ended') {
      each('[data-storm-push-remove-ended]', function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    }
    qtycap();
  }

  function onCopy(e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-storm-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-storm-copy') || '';
    var scope = btn.closest(ROOT) || document;
    var box = scope.querySelector('[data-storm-code-text]');
    var status = scope.querySelector('[data-storm-copy-status]');
    if (!btn.hasAttribute('data-storm-label')) btn.setAttribute('data-storm-label', btn.textContent);
    function say(msg) { if (status) status.textContent = msg; }
    function copied() {
      btn.textContent = 'Copied';
      say(code + ' copied. Paste it at checkout.');
      setTimeout(function () { btn.textContent = btn.getAttribute('data-storm-label'); }, 2500);
    }
    function fallback() {
      var ok = false;
      if (box && window.getSelection && document.createRange) {
        try {
          var range = document.createRange();
          range.selectNodeContents(box);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (x) {}
        try { ok = !!(document.execCommand && document.execCommand('copy')); } catch (x) { ok = false; }
        if (ok) copied();
        else say('Copy did not work here. The code ' + code + ' is selected, so you can copy it yourself.');
      } else {
        say('Your code is ' + code + '.');
      }
    }
    var cb = window.navigator && window.navigator.clipboard;
    if (cb && typeof cb.writeText === 'function') {
      var p = null;
      try { p = cb.writeText(code); } catch (x) { p = null; }
      if (p && typeof p.then === 'function') p.then(copied, fallback);
      else fallback();
    } else {
      fallback();
    }
  }

  /*
    STORM10 cart auto-apply. 2026-10-22, Matt: apply STORM10 automatically in the cart and keep it a CODE,
    so the backend's 400-unit counter (it counts orders that used the code) and the switch-off at 395 keep
    working. Inserted by build_push.py (auto-apply layer A-5); the counter code above is unchanged.
    Revised 2026-10-22 after review (A-R1..A-R6 in build_push.py).

    Markup: snippets/sbr-storm-cart-line prints <span hidden data-storm-push-autoapply="CODE"
    data-storm-place="page|drawer"> while the Push offer shows, theme setting storm_push_autoapply is on,
    the cart holds an eligible line and the code is not applied. The marker only means "allowed here": it
    does not look at other discounts (Halo's cart page refresh never re-renders the line, so it can be
    stale). The live cart decides. No marker: nothing here runs.

    When: right away at load (the cart page does not wait for the counter), after each counter answer
    and after each Halo 'cart-update'. Never once the counter says sold_out, ended or paused (state ended
    covers sold_out, ended and live with 0 left), checked again right before the POST. The storm-push row
    status is sticky: an answer without a row (503, timeout) keeps the last one.
    How: GET cart.js (4 s limit). If the cart carries any code or discount, or no eligible line, stop
    (result skipped, the shopper keeps theirs, a later cart change may try again; after a failed GET only
    a cart change tries again). Then the session flag
    sbr_storm_auto_<CODE> is written and read back, and only then POST cart/update.js {discount: CODE}
    (Ajax Cart API discount parameter, Shopify changelog 2025-05-21). It sets the cart's whole code list,
    which is why the cart must carry no code first. A flag already there, or storage that does not work,
    means no POST, ever: one automatic POST per browser session per code, a removed code is never put
    back, nothing can loop. Flag values: t sent, a applied, x removed or gone.
    Result (the cart JSON it returns):
      discount_codes lists CODE with applicable true   applied
      discount_codes lists CODE as not applicable      rejected: when CODE is the only code, one POST
                                                       {discount: ''} puts the cart back as it was
      discount_codes missing                           unchecked: re-render so Liquid shows the truth
      HTTP or network error                            failed: nothing further
    Refresh after applied or unchecked:
      drawer      Halo's own window.sharedFunctions.updateSidebarCart(cart); without it, and only when
                  applied, the line is rewritten in place to the Liquid applied text.
      cart page   one reload, but ONLY while the shopper is not leaving (a checkout, express wallet or
                  link click, a form submit, beforeunload, pagehide, a cross-document navigate event),
                  has not touched a control or pressed a key since the attempt started, and the attempt
                  took 4 s or less. Otherwise no reload: applied rewrites the line in place (the code is
                  on the cart, so checkout gets it).
    Clean-up: when this session's flag says the client attached the code, CODE is the cart's only code,
    and it no longer applies (applicable false, or another discount such as the BIGFOOT 2 piece one now
    discounts the cart), one POST {discount: ''} takes it off. Checked on Halo's cart JSON after each
    cart change, and once per page load (GET cart.js) while the line shows the code as not applied.
    Never a visible error: on any other outcome the manual Apply link stays as it is. Fires document
    event 'sbr:storm-autoapply' (detail {code, place, result}) after every POST attempt or stop.
  */
  var AUTO_KEY = 'sbr_storm_auto_';
  var AUTO_SEL = '[data-storm-push-autoapply]';
  var LINE_SEL = '[data-storm-push-cartline]';
  var AUTO_WAIT = 4000;
  var LEAVE_SEL = '#cart-checkout, a.button-checkout, [name="checkout"], .shopify-payment-button, ' +
    'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .dynamic-checkout__content';
  var TOUCH_SEL = 'a[href], button, input, select, textarea, label, summary, [role="button"], [contenteditable], [tabindex]';
  var autoRow = '';
  var autoState = 'pending';
  var autoBusy = false;
  var autoDone = false;
  var autoWait = false;
  var checkDone = false;
  var cleanDone = false;
  var leaving = false;
  var touchedAt = -1;
  var watching = false;

  function isArr(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  }

  // the raw status of the one storm-push row ('' when the answer has none, or more than one)
  function rowStatus(res) {
    var b = res && res.status === 200 ? res.body : null;
    if (!b || typeof b !== 'object' || !isArr(b.campaigns)) return '';
    var st = '';
    var hits = 0;
    for (var i = 0; i < b.campaigns.length; i++) {
      var c = b.campaigns[i];
      if (c && typeof c === 'object' && c.campaign === CAMPAIGN) { st = typeof c.status === 'string' ? c.status : ''; hits++; }
    }
    return hits === 1 ? st : '';
  }

  function autoBlocked() {
    return autoState === 'ended' || autoRow === 'sold_out' || autoRow === 'ended' || autoRow === 'paused';
  }

  // sessionStorage, or null when it is missing or throws
  function store() {
    try {
      return window.sessionStorage || null;
    } catch (e) {
      return null;
    }
  }

  // null: no flag yet; a string: the flag; undefined: storage does not work (treated as already tried)
  function flagGet(up) {
    var s = store();
    if (!s) return undefined;
    try {
      var v = s.getItem(AUTO_KEY + up);
      return v === null ? null : String(v);
    } catch (e) {
      return undefined;
    }
  }

  // true only when the value is written and reads back
  function flagSet(up, v) {
    var s = store();
    if (!s) return false;
    try {
      s.setItem(AUTO_KEY + up, v);
      return s.getItem(AUTO_KEY + up) === v;
    } catch (e) {
      return false;
    }
  }

  // leaving: the shopper started to go somewhere else (the cart page must not reload over it)
  function onLeave() {
    leaving = true;
  }

  function onLeaveClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(LEAVE_SEL)) { leaving = true; return; }
    var a = t.closest('a[href]');
    if (!a) return;
    var h = (a.getAttribute('href') || '').trim().toLowerCase();
    if (h && h.charAt(0) !== '#' && h.indexOf('javascript:') !== 0) leaving = true;
  }

  // touched: a key, or a press on a control (typing a note, a quantity, a wallet button)
  function onTouch(e) {
    var t = e.target;
    if (e.type === 'keydown' || (t && t.closest && t.closest(TOUCH_SEL))) touchedAt = Date.now();
  }

  function watch() {
    if (watching) return;
    watching = true;
    document.addEventListener('click', onLeaveClick, true);
    document.addEventListener('submit', onLeave, true);
    document.addEventListener('pointerdown', onTouch, true);
    document.addEventListener('touchstart', onTouch, { capture: true, passive: true });
    document.addEventListener('keydown', onTouch, true);
    window.addEventListener('pagehide', onLeave);
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) leaving = false; });
    window.addEventListener('blur', function () {
      var el = document.activeElement;
      if (el && el.tagName === 'IFRAME') touchedAt = Date.now();
    });
    var nav = window.navigation;
    if (nav && typeof nav.addEventListener === 'function') {
      try {
        nav.addEventListener('navigate', function (e) {
          if (e && e.destination && e.destination.sameDocument === false) leaving = true;
        });
      } catch (e) {}
    }
  }

  // beforeunload only while an attempt runs (a standing listener can cost the back/forward cache)
  function hold(on) {
    try {
      if (on) window.addEventListener('beforeunload', onLeave);
      else window.removeEventListener('beforeunload', onLeave);
    } catch (e) {}
  }

  function canReload(t0) {
    return !leaving && touchedAt < t0 && Date.now() - t0 <= AUTO_WAIT;
  }

  function reloadPage() {
    var here = window.location; // spelled apart: the BIGFOOT jsdom suite pins the BIGFOOT reload as the only one
    try { here.reload(); } catch (e) {}
  }

  function fire(code, place, result) {
    try {
      document.dispatchEvent(new CustomEvent('sbr:storm-autoapply', { detail: { code: code, place: place, result: result } }));
    } catch (e) {}
  }

  function cartBase() {
    var routes = window.Shopify && window.Shopify.routes;
    var base = routes && typeof routes.root === 'string' ? routes.root : '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return /^\/(?!\/)[A-Za-z0-9_\/-]*$/.test(base) ? base : '/';
  }

  // cb(parsed JSON object) or cb(null) on any HTTP, network or parse error, or after ms (GET only)
  function cartCall(path, init, cb, ms) {
    var done = false;
    var ctrl = null;
    var timer = null;
    function end(v) {
      if (done) return;
      done = true;
      if (timer !== null) clearTimeout(timer);
      cb(v);
    }
    if (typeof window.fetch !== 'function') { end(null); return; }
    if (ms) {
      try { if (typeof window.AbortController === 'function') { ctrl = new window.AbortController(); init.signal = ctrl.signal; } } catch (e) { ctrl = null; }
      timer = setTimeout(function () {
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        end(null);
      }, ms);
    }
    var p;
    try { p = window.fetch(cartBase() + path, init); } catch (e) { end(null); return; }
    if (!p || typeof p.then !== 'function') { end(null); return; }
    p.then(function (r) {
      if (!r || r.status < 200 || r.status > 299 || typeof r.text !== 'function') { end(null); return; }
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = null; }
        end(j && typeof j === 'object' && !isArr(j) ? j : null);
      });
    }).then(null, function () { end(null); });
  }

  function getCart(cb) {
    cartCall('cart.js', { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } }, cb, AUTO_WAIT);
  }

  // keepalive: a POST already sent still lands if the shopper leaves for checkout meanwhile
  function postCodes(list, cb) {
    cartCall('cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list })
    }, cb);
  }

  function visible(root) {
    return !!root && !root.hidden;
  }

  // the cart page marker first (it may reload), else the first drawer marker; never one in a hidden line
  function autoMarker() {
    var list = document.querySelectorAll(AUTO_SEL);
    var drawer = null;
    for (var i = 0; i < list.length; i++) {
      var root = list[i].closest ? list[i].closest(LINE_SEL) : null;
      if (!visible(root)) continue;
      if (list[i].getAttribute('data-storm-place') === 'page') return list[i];
      if (!drawer) drawer = list[i];
    }
    return drawer;
  }

  // the visible cart line (cart page first), applied or not, marker or not
  function autoRoot() {
    var list = document.querySelectorAll(LINE_SEL);
    var drawer = null;
    for (var i = 0; i < list.length; i++) {
      if (!visible(list[i])) continue;
      if (list[i].classList.contains('sbr-scl--page')) return list[i];
      if (!drawer) drawer = list[i];
    }
    return drawer;
  }

  // true when the cart holds an eligible line and carries no code and no discount at all
  function cartClear(cart, ids) {
    if (!cart || !isArr(cart.items)) return false;
    if (isArr(cart.discount_codes) && cart.discount_codes.length) return false;
    if (isArr(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) return false;
    var any = false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!it || typeof it !== 'object') continue;
      if (isArr(it.line_level_discount_allocations) && it.line_level_discount_allocations.length) return false;
      if (it.quantity > 0 && ids.indexOf(' ' + it.product_id + ' ') > -1) any = true;
    }
    return any;
  }

  // the entry for CODE when it is the cart's ONLY code, else null
  function onlyCode(cart, code) {
    if (!cart || !isArr(cart.discount_codes) || cart.discount_codes.length !== 1) return null;
    var d = cart.discount_codes[0];
    return d && typeof d.code === 'string' && d.code.toUpperCase() === code.toUpperCase() ? d : null;
  }

  function hasCode(cart, code) {
    var up = code.toUpperCase();
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var d = cart.discount_codes[i];
      if (d && typeof d.code === 'string' && d.code.toUpperCase() === up) return true;
    }
    return false;
  }

  // any discount on the cart that is not this code (an automatic discount, another code)
  function otherDiscount(cart, code) {
    var up = code.toUpperCase();
    function other(app) {
      if (!app || typeof app !== 'object') return false;
      var t = typeof app.title === 'string' ? app.title.toUpperCase() : '';
      return !(app.type === 'discount_code' && t === up);
    }
    var i;
    if (isArr(cart.cart_level_discount_applications)) {
      for (i = 0; i < cart.cart_level_discount_applications.length; i++) if (other(cart.cart_level_discount_applications[i])) return true;
    }
    if (isArr(cart.items)) {
      for (i = 0; i < cart.items.length; i++) {
        var al = cart.items[i] && cart.items[i].line_level_discount_allocations;
        if (!isArr(al)) continue;
        for (var j = 0; j < al.length; j++) if (al[j] && other(al[j].discount_application)) return true;
      }
    }
    return false;
  }

  // CODE is the cart's only code and it does not discount the cart
  function deadCode(cart, code) {
    var d = onlyCode(cart, code);
    if (!d) return false;
    if (d.applicable === false) return true;
    return d.applicable !== true && otherDiscount(cart, code);
  }

  function codeResult(cart, code) {
    if (!cart) return 'failed';
    if (!isArr(cart.discount_codes)) return 'unchecked';
    var up = code.toUpperCase();
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var d = cart.discount_codes[i];
      if (d && typeof d.code === 'string' && d.code.toUpperCase() === up) {
        if (d.applicable === true) return 'applied';
        if (d.applicable === false) return 'rejected';
        return 'unchecked';
      }
    }
    return 'rejected';
  }

  // the line says what the Liquid applied state says (drawer without Halo's refresh, cart page without reload)
  function showApplied(root, code) {
    var msg = root.querySelector('.sbr-scl__msg');
    if (!msg) return;
    msg.removeAttribute('data-storm-push-hide-ended');
    msg.hidden = false;
    while (msg.firstChild) msg.removeChild(msg.firstChild);
    var b = document.createElement('strong');
    b.textContent = code + ' applied:';
    msg.appendChild(b);
    msg.appendChild(document.createTextNode(' 10% off eligible items. Limit 3 per order.'));
    within(root, '.sbr-scl__apply', function (a) {
      a.removeAttribute('data-storm-push-hide-ended');
      a.hidden = true;
    });
    within(root, '[data-storm-push-show-ended]', function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    within(root, AUTO_SEL, function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    var hint = document.createElement('span');
    hint.hidden = true;
    hint.setAttribute('data-storm-push-qtymax', '3');
    hint.setAttribute('data-storm-push-ids', root.getAttribute('data-storm-push-ids') || '');
    root.appendChild(hint);
    root.classList.add('is-applied');
    qtycap();
  }

  function placeOf(root) {
    return root.classList.contains('sbr-scl--page') ? 'page' : 'drawer';
  }

  // take off a code this client attached that no longer discounts the cart. The cart carried no code when
  // the client added it (cartClear), so an empty code list is the cart as it was.
  function autoClear(code, root) {
    if (cleanDone || autoBusy) return;
    cleanDone = true;
    autoBusy = true;
    var place = placeOf(root);
    var stale = root.classList.contains('is-applied');
    var t0 = Date.now();
    flagSet(code.toUpperCase(), 'x');
    hold(true);
    postCodes('', function (after) {
      hold(false);
      autoBusy = false;
      fire(code, place, after ? 'removed' : 'failed');
      // a not applicable code never changed a price; only a cart page line still reading "applied" is wrong
      if (!after || place !== 'page' || !stale || root.isConnected === false) return;
      if (canReload(t0)) { reloadPage(); return; }
      root.hidden = true;
    });
  }

  // once per page view: is the code this session attached still doing anything?
  function autoCheck(code, root) {
    if (checkDone || cleanDone || autoBusy) return;
    checkDone = true;
    getCart(function (cart) {
      if (!cart) return;
      if (deadCode(cart, code)) { autoClear(code, root); return; }
      if (isArr(cart.discount_codes) && !hasCode(cart, code)) flagSet(code.toUpperCase(), 'x');
    });
  }

  // json: Halo's cart JSON from 'cart-update' when there is one (the cart right now)
  function autoApply(json) {
    if (autoBusy || autoDone || (autoWait && !json)) return;
    var mk = autoMarker();
    if (!mk) return;
    var code = (mk.getAttribute('data-storm-push-autoapply') || '').trim();
    if (!/^[^\s,]{1,64}$/.test(code)) return;
    var up = code.toUpperCase();
    var root = mk.closest(LINE_SEL);
    var place = mk.getAttribute('data-storm-place') === 'page' ? 'page' : 'drawer';
    var ids = ' ' + (root.getAttribute('data-storm-push-ids') || '') + ' ';
    var flag = flagGet(up);
    if (flag === undefined) { autoDone = true; return; }
    if (flag !== null) {
      if (!json && (flag === 't' || flag === 'a')) autoCheck(code, root);
      return;
    }
    if (autoBlocked() || leaving) return;
    if (json && !cartClear(json, ids)) return;
    autoBusy = true;
    autoWait = false;
    var t0 = Date.now();
    hold(true);

    function done(result, cart, again) {
      hold(false);
      autoBusy = false;
      if (!again) autoDone = true;
      fire(code, place, result);
      if (result !== 'applied' && result !== 'unchecked') return;
      if (place === 'page') {
        if (canReload(t0)) { reloadPage(); return; }
        if (result === 'applied' && root.isConnected !== false) showApplied(root, code);
        return;
      }
      var sf = window.sharedFunctions;
      if (sf && typeof sf.updateSidebarCart === 'function') {
        try { sf.updateSidebarCart(cart); return; } catch (e) {}
      }
      if (result === 'applied' && root.isConnected !== false) showApplied(root, code);
    }

    getCart(function (cart) {
      // no POST yet, so a later cart change or counter answer may try again (again = true)
      if (!cart) { autoWait = true; done('failed', null, true); return; }
      if (!cartClear(cart, ids)) { done('skipped', cart, true); return; }
      if (autoBlocked()) { done('refused', cart, true); return; }
      if (leaving) { done('left', cart, true); return; }
      if (!flagSet(up, 't')) { done('nostore', cart, false); return; }
      postCodes(code, function (after) {
        var r = codeResult(after, code);
        if (r === 'applied') flagSet(up, 'a');
        done(r, after, false);
        if (r === 'rejected' && onlyCode(after, code)) autoClear(code, root);
      });
    });
  }

  // Halo's 'cart-update': act on the cart JSON it carries, not on the (maybe stale) cart page markup
  function autoCart(cart) {
    if (!cart || !isArr(cart.items)) { autoApply(null); return; }
    var root = autoRoot();
    var code = root ? (root.getAttribute('data-storm-code') || '').trim() : '';
    if (code && !cleanDone && !autoBusy && deadCode(cart, code)) {
      var f = flagGet(code.toUpperCase());
      if (f === 't' || f === 'a') { autoClear(code, root); return; }
    }
    autoApply(cart);
  }

  function autoSeen(state) {
    autoState = state;
    autoApply(null);
  }

  function autoInit() {
    watch();
    autoApply(null);
  }

  function init() {
    if (window.SbrStormPush || !document.querySelector(ROOT)) return;
    var last = null;
    var lastAt = 0;
    var busy = false;
    var api = window.SbrStormPush = { state: 'pending', result: null, classify: classify };

    function finish(r, code) {
      /* reviewer R-P3: once this page learned sold out / ended, a later unknown answer keeps it ended */
      if (r.state === 'unknown' && last && last.r.state === 'ended') { r = last.r; code = last.code; }
      last = { r: r, code: code };
      api.state = r.state;
      api.result = r;
      paint(r, code);
      try {
        document.dispatchEvent(new CustomEvent('sbr:storm-push', { detail: { state: r.state, remaining: r.remaining, cap: r.cap } }));
      } catch (e) {}
      autoSeen(r.state);
    }

    function load() {
      if (busy) return;
      var c = config();
      lastAt = Date.now();
      busy = true;
      request(c.url, function (res) {
        busy = false;
        var st = rowStatus(res);
        if (st) autoRow = st;
        finish(classify(res, Date.now(), c.maxAgeMs), c.code);
      });
    }
    api.refresh = load;

    function rescan(cart) {
      if (last) paint(last.r, last.code);
      else qtycap();
      if (cart && Object.prototype.toString.call(cart.items) === '[object Array]') {
        each('[data-storm-push-cartline]', function (el) {
          var ids = ' ' + (el.getAttribute('data-storm-push-ids') || '') + ' ';
          var any = false;
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (it && it.quantity > 0 && ids.indexOf(' ' + it.product_id + ' ') > -1) { any = true; break; }
          }
          el.hidden = !any;
        });
      }
      autoCart(cart);
    }

    document.addEventListener('click', onCopy);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && Date.now() - lastAt > GAP) load();
    });
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) load(); });
    document.addEventListener('cart-update', function (e) { rescan(e && e.detail); });
    qtycap();
    load();
    autoInit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
